<template>
    <table-component-buefy
            v-if="mixin.loaded"
            :content="invoices"
            :headings="table_headings"
            :item_keys="table_keys"
            :display_spec="invoiceSpecs"
            :total_items="mixin.total_items"
            :hide_table_search="true"
            :default_search="String(caseId)"
            :pagination_callback="mixin.loadItems">
    </table-component-buefy>
</template>
<script>
  import { mapActions, mapState } from 'vuex'
  import { invoiceSpecs } from '@/display_context/display_context'
  import { loadItemsMixin } from '@/mixins/mixins'
  import TableComponentBuefy from '@/components/layout/table/TableComponentBuefy'

  export default {
    name: 'case-invoice-view',
    mixins: [loadItemsMixin],
    components: {
      TableComponentBuefy
    },
    data () {
      return {
        table_headings: ['Invoice No.', 'Customer', 'Amount', 'Created', 'State'],
        table_keys: ['invoiceLink', 'customerName', 'totalSum', 'created', 'state'],
        invoiceSpecs: invoiceSpecs,
        mixin: {
          actionMethod: this.getInvoices,
          actionParams: { case: this.caseId }
        }
      }
    },
    props: {
      caseId: {
        required: true
      }
    },
    computed: {
      ...mapState({
        invoices: state => state.invoiceModule.invoices
      })
    },
    methods: {
      ...mapActions([
        'getInvoices'
      ])
    }
  }
</script>
